import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import selector from 'modules/Auth/selectors.js'
import request from 'utils/request'
import SuccessMessage from 'utils/SuccessMessage'

export const SET_USER_METRICS = 'corporate/SET_USER_METRICS'
export const SET_USER_LIST = 'corporate/SET_USER_LIST'
export const SET_SINGLE_USER = 'corporate/SET_SINGLE_USER'

export const setUserMetrics = data => {
  return {
    type: SET_USER_METRICS,
    data,
  }
}

export const setUserList = data => {
  return {
    type: SET_USER_LIST,
    data,
  }
}

export const setSingleUser = data => {
  return {
    type: SET_SINGLE_USER,
    data,
  }
}

export const getUserMetrics = () => async (dispatch, getState) => {
  try {
    const state = getState()
    const instituteCampusId = selector.getInstituteDetails(state)?.id
    const response = await request.get(
      `/users/metrics?instituteCampusId=${instituteCampusId}`
    )
    dispatch(setUserMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getUserList =
  ({ searchValue, sortBy, userRoleValue, userStatus, pageNum }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteId = selector.getInstituteCampusId(state)

      const search = searchValue ? `&search=${searchValue}` : ''

      const sortKey = sortBy?.columnKey ? `&sortBy=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''

      const userRole = userRoleValue?.length > 0 ? `&Role=${userRoleValue}` : ''
      const status = userStatus?.length > 0 ? `&status=${userStatus}` : ''

      const response = await request.get(
        `/user?pageLimit=10&currentPage=${pageNum}&instituteId=${instituteId}${sortKey}${sortOrder}${search}${userRole}${status}`
      )
      dispatch(setUserList(response?.data?.data))
      return false
    } catch (error) {
      return false
    }
  }

export const createUser =
  ({ payload }, eventId) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteId = selector.getInstituteDetails(state)?.instituteId
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      let updatedPayload = {
        ...payload,
        instituteId: instituteId,
        instituteCampusId: instituteCampusId,
        eventId: eventId,
      }

      const response = await request.post(`/user`, updatedPayload)
      return response
    } catch (error) {
      return error
    }
  }

export const getSingleUser =
  ({ userId }) =>
  async (dispatch, getState) => {
    try {
      const response = await request.get(`/user/${userId}`)
      dispatch(setSingleUser(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const updateUser =
  ({ userId, payload }) =>
  async (dispatch, getState) => {
    try {
      let updatedPayload = {
        ...payload,
      }
      const response = await request.put(`/user/${userId}`, updatedPayload)
      return response
    } catch (error) {
      return error
    }
  }

export const updateUserStatus =
  ({ userId, status }) =>
  async (dispatch, getState) => {
    try {
      const response = await request.patch(`/user/${userId}/status`, {
        status: status,
      })
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage(
          status
            ? 'User activated successfully!'
            : 'User inactivated successfully!'
        )
      }

      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const deleteUser =
  ({ userId }) =>
  async (dispatch, getState) => {
    try {
      const response = await request.delete(`/user/${userId}`)
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('User Deleted Successfully!')
      }
      return response
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }
